// Reusable Button component with variants
const Button = ({ children, onClick, variant = 'primary', className = '' }) => {
    const baseStyle = "px-6 py-3 rounded-2xl font-medium transition-all duration-300 transform active:scale-95 flex items-center justify-center gap-2";
    const variants = {
        primary: "bg-black text-white hover:bg-gray-800 shadow-lg hover:shadow-xl",
        secondary: "bg-gray-100 text-gray-700 hover:bg-gray-200",
        ghost: "text-gray-500 hover:bg-gray-50",
        outline: "border-2 border-gray-200 text-gray-700 hover:border-gray-400",
        danger: "bg-red-50 text-red-600 hover:bg-red-100"
    };

    return (
        <button onClick={onClick} className={`${baseStyle} ${variants[variant]} ${className}`}>
            {children}
        </button>
    );
};

export default Button;
